import React, { useState, useEffect } from 'react';
import HeroImage1 from '../images/hero-images/pragicts-our-perspectives-banner-afterthought.jpg'; 
import HeroImage2 from '../images/hero-images/pragicts-our-perspectives-banner-keep-it-simple.jpg'; 
import HeroImage3 from '../images/hero-images/pragicts-our-perspectives-banner-right-balance.jpg'; 
import HeroImage4 from '../images/hero-images/pragicts-our-perspectives-banner-carved-in-stone.jpg'; 
import HeroImage5 from '../images/hero-images/pragicts-our-perspectives-look-beyond-the-marketning-hype.jpg'; 
import HeroImage6 from '../images/hero-images/pragicts-our-perspectives-banner-one-pill-solution.jpg'; 

const slides = [
    {
        id: 1,
        image: HeroImage1,
        mainText: 'Engineering is not an <br /> <span>afterthought</span>',
    },
    {
        id: 2,
        image: HeroImage2,
        mainText: 'Keep it<br /> <span>simple</span>',
    },
    {
        id: 3,
        image: HeroImage3,
        mainText: 'The challenge is to get the <br /> <span>right balance of engineering,</span><br />Not under or over.',
    },
    {
        id: 4,
        image: HeroImage4,
        mainText: 'Nothing is,<br /> <span>carved in stone.</span><br />Most things change, evolve, replaced and disrupted.',
    },
    {
        id: 5,
        image: HeroImage5,
        mainText: 'Avoid marketing hype, look under to see the<br /> <span>substance, limitations, strengths, and context.</span>',
    },
    {
        id: 6,
        image: HeroImage6,
        mainText: 'There is no <br /> <span>one-pill solution.</span>',
    },
];

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                          
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides;
